import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import MuuriGrid from "muuri";
import "./style.css";

import SongItem from "./list-item";
import { handlePlay, handleRemove, handleAdd } from "../actions";
import { PlayerStateContext, SocketStateContext } from "../../../../provider";

import { Col, Box, Text, Row, Img } from "../../../../comps";
import { Theme } from "../../../../theme/theme-provider";

import { queueArt } from "../../../../theme/image";

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const Head = styled(Row)`
  width: 98%;
  height: 30px;
  /* align-items: center; */
  border-bottom: 1px solid ${({ theme }) => theme.textColor.light};
`;

const ListWrapper = styled(Col)`
  width: 100%;
  height: calc(100% - 40px);
  overflow-y: scroll;
  overflow-x: hidden;
  align-items: center;
  &::-webkit-scrollbar {
    width: 0px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 0px;
  }
  &:hover {
    &::-webkit-scrollbar {
      width: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.color.GRAY_2};
    }
    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.color.GRAY_1};
      border-radius: 20px;
    }
  }
`;

const List = styled(Box)`
  width: 98%;
`;

const Art = styled(Col)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: ${({ verticallyCenter }) => (verticallyCenter ? "30vh" : "auto")};
  align-items: center;
  justify-content: ${({ verticallyCenter }) =>
    verticallyCenter ? "center" : ""};
  cursor: pointer;
`;

export default ({ roomInfo, refresh, time }) => {
  const [socketInfo] = useContext(SocketStateContext);
  const [playerState] = useContext(PlayerStateContext);
  const { isPlaying, currentSongIndex } = playerState;

  const { id, queue } = roomInfo || {};

  const {
    isJoined,
    room: { id: cri },
  } = socketInfo;
  const isThisRoomJoined = isJoined && cri === id;

  // >=0 if a song is being played from this room
  const roomSongIdx = isThisRoomJoined ? currentSongIndex : -1;

  useEffect(() => {
    let grid = "";
    if (queue && queue.length > 0)
      grid = new MuuriGrid(".roomQueueGrid", {
        dragEnabled: false,
        layout: { fillGaps: true, alignLeft: true, alignTop: true },
      });
  }, [time]);

  const isQueueEmpty = !queue || queue.length === 0;

  return (
    <Wrapper>
      <Head>
        <Text
          marginLeft="10px"
          fontSize="26px"
          color={Theme.color.GRAY_0}
          fontWeight="500"
        >{`Queue`}</Text>
      </Head>
      <ListWrapper>
        <List>
          <div class="grid roomQueueGrid">
            {!isQueueEmpty &&
              queue.map((song, index) => {
                return (
                  <SongItem
                    key={index}
                    song={song}
                    isFocused={index === roomSongIdx}
                    isPlaying={isPlaying && index === roomSongIdx}
                    onPlay={() => {
                      handlePlay({
                        roomInfo,
                        refresh,
                        index,
                      });
                    }}
                    onRemove={() => {
                      handleRemove({
                        roomInfo,
                        refresh,
                        index,
                      });
                    }}
                  />
                );
              })}
          </div>
          <Art
            verticallyCenter={isQueueEmpty}
            onClick={() => {
              handleAdd({ refresh, roomInfo });
            }}
          >
            <Img width="30%" src={queueArt} />
            <Text
              fontSize="14px"
              fontWeight={600}
              color={Theme.color.GRAY_1}
            >{`Add more songs to queue`}</Text>
          </Art>
        </List>
      </ListWrapper>
    </Wrapper>
  );
};
